import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a7a04150"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editTimetableInput" }
const _hoisted_2 = ["aria-label"]

import { IconText, PortList } from '..';
import { Port } from '../../types';
import { IconPositionType } from '../../types/IconPositionType';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditTimetableInput',
  props: {
    ports: {},
    toggleInput: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(PortList), {
      ports: _ctx.ports,
      "icon-name": "searchMapPin"
    }, null, 8, ["ports"]),
    _createElementVNode("button", {
      "aria-label": _ctx.$t('Edit timetable search input aria label'),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleInput && _ctx.toggleInput(...args)))
    }, [
      _createVNode(_unref(IconText), {
        "icon-name": "editRed",
        text: _ctx.$t('Edit'),
        "icon-pos": _unref(IconPositionType).PosLeft
      }, null, 8, ["text", "icon-pos"])
    ], 8, _hoisted_2)
  ]))
}
}

})